/** Tur qidiruvi, K3 (Brief 12). */
export const ruB12Search = {
  "tq12.tab.cruise": "Круиз",
  "tq12.clientChip": "Для клиента:",
  "tq12.clientChipDeal": "Сделка №{number}",
  "tq12.selectionCount": "Подборка · {count}",
  "tq12.inSelection": "В подборке",
  "tq12.sel.empty": "Пока ничего не выбрано. Нажмите «+ В подборку» в результатах.",
  "tq12.sel.brutto": "Клиент видит только цену брутто.",
  "tq12.sel.bruttoDeal": "Клиент видит только цену брутто. Подборка попадёт в историю сделки №{number}.",
  "tq12.sel.needVariant": "Сначала выберите вариант",
  "tq12.sel.cardSent": "{count} вар. ушло в чат карточкой · только брутто",
  "tq12.field.from": "Откуда",
  "tq12.field.to": "Куда",
  "tq12.field.window": "Период вылета",
  "tq12.field.nights": "Ночей",
  "tq12.field.who": "Кто едет",
  "tq12.field.windowFrom": "Начало",
  "tq12.field.windowTo": "Конец",
  "tq12.field.nightsFrom": "От",
  "tq12.field.nightsTo": "До",
  "tq12.field.adults": "Взрослые",
  "tq12.field.childAges": "Возраст детей, через запятую",
  "tq12.field.pick": "Выберите",
  "tq12.field.charterAndRegular": "чартер и регулярные",
  "tq12.field.charterOnly": "только чартер",
  "tq12.who.adults": "{count} взр.",
  "tq12.who.children": "{count} реб. ({ages})",
  "tq12.aiPlaceholder": "Например: Египет, начало ноября, 2 взрослых + ребёнок 7 лет, до 1 500 $, у моря",
  "tq12.aiFill": "В поля",
  "tq12.quick": "Быстрый выбор",
  "tq12.quickFrom": "от {price}",
  "tq12.calendar": "Календарь цен · самое дешёвое по дню вылета",
  "tq12.filter.resort": "Курорт",
  "tq12.filter.anyResort": "Любой курорт",
  "tq12.filter.level": "Категория отеля",
  "tq12.filter.board": "Питание",
  "tq12.filter.operators": "Туроператоры",
  "tq12.filter.important": "Важно",
  "tq12.filter.halal": "Халяльное меню",
  "tq12.filter.from": "от {price}",
  "tq12.filter.open": "Фильтры",
  "tq12.seat.legend": "Наличие мест:",
  "tq12.seat.ok": "есть",
  "tq12.seat.few": "мало (осталось)",
  "tq12.seat.none": "нет · стоп-сейл",
  "tq12.seat.hideStop": "Скрыть стоп-сейлы",
  "tq12.summary": "{hotels} отелей · от {operators} операторов",
  "tq12.compared": "Цены сравнены",
  "tq12.partial.title": "{names} не ответили.",
  "tq12.partial.body": "Результаты неполные, показаны цены остальных поставщиков.",
  "tq12.allFailed.title": "Поставщики не ответили",
  "tq12.allFailed.body": "Проблема в сети или на стороне поставщика. Пакеты агентства остаются в поиске.",
  "tq12.allFailed.retry": "Искать снова",
  "tq12.noResults.title": "По этим параметрам мест нет",
  "tq12.noResults.body": "Сдвиньте дату на ±3 дня или снимите фильтр по звёздам.",
  "tq12.noResults.widen": "±3 дня",
  "tq12.noFilter.body": "Нет отелей по этим фильтрам. Расширьте питание или категорию.",
  "tq12.noFilter.reset": "Сбросить фильтры",
  "tq12.provider.results": "{count}",
  "tq12.provider.empty": "0 результатов",
  "tq12.provider.error": "ошибка",
  "tq12.provider.waiting": "ожидание",
  "tq12.start.title": "Начните поиск",
  "tq12.start.body": "Выберите страну и дату и нажмите «Найти». Опросим всех операторов сразу.",
  "tq12.noOperator.title": "Туроператор не подключён",
  "tq12.noOperator.body": "Для поиска нужен хотя бы один логин туроператора или ключ API.",
  "tq12.noOperator.bodyStaff": "Для поиска нужен хотя бы один туроператор. Попросите владельца агентства подключить его.",
  "tq12.noOperator.action": "Подключить туроператора",
  "tq12.error.title": "Поиск не сработал",
  "tq12.error.body": "Сервер не ответил. Введённые данные сохранены, страницу можно перезагрузить.",
  "tq12.card.more": "Ещё {count} цен операторов",
  "tq12.card.fewer": "Скрыть",
  "tq12.card.detail": "Подробнее",
  "tq12.card.soldTimes": "За последний месяц вы продали этот отель {count} раз",
  "tq12.card.ratingSource": "Рейтинг {source}",
  "tq12.card.noPhoto": "Нет фото",
  "tq12.card.nettoLine": "нетто {netto} · прибыль {profit}",
  "tq12.card.bookReminder": "Забронировав на сайте оператора, внесите номер брони в сделку.",
  "tq12.detail.ratings": "Рейтинги",
  "tq12.detail.offers": "Все цены",
  "tq12.detail.photos": "Фото",
  "tq12.hotel.city": "Город или отель",
  "tq12.hotel.checkIn": "Заезд",
  "tq12.hotel.checkOut": "Выезд",
  "tq12.hotel.guests": "Гости и номера",
  "tq12.hotel.guestsValue": "{adults} взр. · 1 номер",
  "tq12.hotel.pricePerNight": "Цена за ночь",
  "tq12.hotel.priceMin": "Цена от",
  "tq12.hotel.priceMax": "Цена до",
  "tq12.hotel.area": "Район",
  "tq12.hotel.anyArea": "Любой район",
  "tq12.hotel.conditions": "Условия",
  "tq12.hotel.summary": "{count} отелей · {dates}, {nights} ноч. · {adults} взр.",
  "tq12.hotel.night": "1 ночь · всего {total}",
  "tq12.hotel.nettoNight": "нетто {netto} / всего",
  "tq12.hotel.freeCancel": "Бесплатная отмена · до {date}",
  "tq12.hotel.nonRefundable": "Невозвратный тариф",
  "tq12.hotel.moreSources": "Ещё {count} источн.",
  "tq12.hotel.hideSources": "Скрыть",
  "tq12.hotel.mapLarger": "Карта крупнее",
  "tq12.hotel.mapSmaller": "Карта мельче",
  "tq12.hotel.start": "Выберите город и даты и нажмите «Найти».",
  "tq12.hot.within": "До вылета {count} дн.",
  "tq12.hot.budget": "На двоих, до",
  "tq12.hot.all": "Все · {count}",
  "tq12.hot.seats": "Осталось мест: {count}",
  "tq12.hot.matched": "Подходит клиентов: {count}",
  "tq12.hot.send": "Отправить клиенту",
  "tq12.hot.fromAll": "Все города",
  "tq12.avia.note": "Цена от партнёра. Покупка на сайте партнёра.",
  "tq12.avia.dates": "Даты",
  "tq12.avia.datesPick": "Выберите дату",
  "tq12.avia.depart": "Туда",
  "tq12.avia.return": "Обратно",
  "tq12.avia.passengers": "Пассажиры и класс",
  "tq12.avia.passengersValue": "{count} взр. · Эконом",
  "tq12.avia.adults": "Пассажиры",
  "tq12.avia.direct": "Прямой",
  "tq12.avia.stopCount": "Пересадок: {count}",
  "tq12.avia.hand": "Ручная кладь {kg} кг",
  "tq12.avia.bag": "Багаж {kg} кг",
  "tq12.avia.noBag": "Без багажа",
  "tq12.avia.withBag": "С багажом",
  "tq12.avia.buy": "Купить",
  "tq12.avia.start": "Выберите маршрут и дату и нажмите «Найти».",
  "tq12.avia.bestFor": "{airline} · {duration}",
  "tq12.pkg.yaqin": "Ближайшие вылеты",
  "tq12.pkg.seats": "{count} мест",
  "tq12.pkg.perPerson": "на 1 чел.",
  "tq12.pkg.nettoLine": "нетто {netto} · прибыль {profit}",
  "tq12.pkg.soldLine": "Продано {sold} / {quota} мест · {pct}%",
  "tq12.pkg.new": "Новый пакет",
  "tq12.cruise.region": "Регион",
  "tq12.cruise.port": "Порт отправления",
  "tq12.cruise.window": "Период",
  "tq12.cruise.nights": "Ночей",
  "tq12.cruise.passengers": "Пассажиры",
  "tq12.cruise.any": "Любой",
  "tq12.cruise.summaryCount": "Круизов: {count}",
  "tq12.cruise.priceFrom": "от, на {count} чел.",
  "tq12.cruise.priceAbout": "примерно, на {count} чел.",
  "tq12.cruise.estimate": "Примерная цена · точная по запросу",
  "tq12.cruise.request": "Отправить запрос",
  "tq12.cruise.requested": "Запрос отправлен · задача открыта, ответ в течение 24 часов",
  "tq12.cruise.back": "Результаты",
  "tq12.cruise.detailLine": "{line} · {dates} · {nights} ноч. · из {port}",
  "tq12.cruise.route": "Маршрут по дням",
  "tq12.cruise.day": "День {day}",
  "tq12.cruise.dayDate": "День {day} · {date}",
  "tq12.cruise.atSea": "В море",
  "tq12.cruise.cabins": "Категории кают",
  "tq12.cruise.cabin": "Каюта",
  "tq12.cruise.size": "Площадь",
  "tq12.cruise.capacity": "Вместимость",
  "tq12.cruise.board": "Питание",
  "tq12.cruise.priceFor": "На {count} чел.",
  "tq12.cruise.none.title": "На эти даты круизов нет",
  "tq12.cruise.none.body": "Расширьте период или выберите другой порт.",
  "tq12.cruise.noProvider.title": "Поставщик круизов не подключён",
  "tq12.cruise.noProvider.body": "Система пока не получает цены сама. Отправьте запрос: оператору откроется задача, и он подберёт круиз вручную.",
  "tq12.cruise.start.title": "Поиск круизов",
  "tq12.cruise.start.body": "Выберите регион и даты и нажмите «Найти».",
  "tq12.cruise.error": "Не удалось получить круизы. Попробуйте ещё раз.",
  "tq12.sel.kind.cruise": "Круиз",
  "tq12.weekday.0": "Вс",
  "tq12.weekday.1": "Пн",
  "tq12.weekday.2": "Вт",
  "tq12.weekday.3": "Ср",
  "tq12.weekday.4": "Чт",
  "tq12.weekday.5": "Пт",
  "tq12.weekday.6": "Сб",
} as const;
